import { render } from "./BackgroundPage.vue?vue&type=template&id=4f5c4acc&ts=true"
import script from "./BackgroundPage.vue?vue&type=script&lang=ts"
export * from "./BackgroundPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__